import { render } from "./PlayerReadAlongPanel.vue?vue&type=template&id=1d1a215a&scoped=true"
import script from "./PlayerReadAlongPanel.vue?vue&type=script&lang=js"
export * from "./PlayerReadAlongPanel.vue?vue&type=script&lang=js"

import "./PlayerReadAlongPanel.vue?vue&type=style&index=0&id=1d1a215a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d1a215a"]])

export default __exports__